module.exports = __webpack_public_path__ + "static/media/afl-draft-ver-cen-white.de34f70f.svg";